const PATHS = {
  APPLICATION: 'application',
  ASSETS: 'assets',
  BEFORE_YOU_GO: 'before-you-go',
  WELCOME: 'welcome',
  DASHBOARD: 'dashboard',
  HOUSEHOLD: 'household',
  VERIFICATION: 'verification',
  CREDIT_CRIMINAL_CHECK: 'credit-criminal-check',
  IDENTIFYING_DETAILS: 'identifying-details',
  DOCUMENTATION: 'documentation',
  DOCUMENTS_AND_UPLOADS: 'documents-and-uploads',
  APPLICATION_SUBMISSION: 'application-submission',
  MARITAL_STATUS: 'marital-status',
  MOVE_IN: 'move-in',
  PAYMENTS: 'payments',
  WAGES_AND_INCOME: 'wages-and-income',
  AFFORDA_ASSETS: 'afforda-assets',
};

export const DOCUMENTS_AND_UPLOADS_PATHS = {
  OVERVIEW: 'overview',
  TASK_LIST: 'task-list',
};

export const APPLICATION_SUBMISSION_PATHS = {
  SIGNATURE_AND_REPRESENTATION: 'signature-and-representation',
  SUMMARY: 'summary',
};

export const HOUSEHOLD_PATHS = {
  MEMBERS: 'members',
  DESIGNATION: 'designation',
  MARITAL_STATUS: 'marital-status',
  MINOR_RELATIONSHIP: 'minors-relationship',
  STUDENT_STATUS: 'student-status',
  FULL_TIME_STUDENT: 'full-time-student',
  ADDITIONAL_MINORS: 'additional-minors',
  LIVE_IN_AIDE: 'live-in-aide',
  SUMMARY: 'summary',
  INVITE: 'invite',
};

export const PAYMENTS_PATHS = {
  OVERVIEW: 'overview',
  FORM: 'form',
  RECEIPT: 'receipt',
};

export const IDENTIFYING_DETAILS_PATHS = {
  OVERVIEW: 'overview',
  IDENTIFICATION: 'identification',
  IDENTIFICATION_ALTERNATE: 'identification-alternate',
  RESIDENTIAL_HISTORY: 'residential-history',
  BACKGROUND: 'background',
  SUMMARY: 'summary',
};

export const CREDIT_CRIMINAL_CHECK_PATHS = {
  MIDDLE_NAMES_AND_SUFFIXES: 'middle-names-and-suffixes',
  MOVE_IN_PREFERENCES: 'move-in-preferences',
  CONSENT: 'consent',
  SUMMARY: 'summary',
  COMPLETE: 'complete',
};

export const RESIDENTIAL_HISTORY_PATHS = {
  CURRENT: 'current',
  PREVIOUS: 'previous',
  LIVE_TOGETHER: 'live-together',
};

export const WAGES_AND_INCOME_PATHS = {
  CHOICES_1: 'choices-1',
  CHOICES_2: 'choices-2',
  CHOICES_3: 'choices-3',
  CHOICES_4: 'choices-4',
  DETAILS_NO_INCOME: 'no-income',
  DETAILS_CURRENT_JOB: 'job',
  DETAILS_ANTICIPATED_JOB: 'anticipated',
  DETAILS_LAST_JOBS: 'last-job',
  DETAILS_CHILD_SUPPORT: 'child-support',
  DETAILS_ALIMONY: 'alimony',
  DETAILS_SOCIAL_SECURITY: 'social-security',
  DETAILS_OTHER_INCOME: 'other',
  DETAILS_PUBLIC_ASSISTANCE: 'public',
  DETAILS_GIFTS: 'gift',
  DETAILS_UNEMPLOYMENT: 'unemployment',
  DETAILS_PENSION: 'pension',
  DETAILS_ONLINE: 'online',
  DETAILS_TRUST: 'trust',
  DETAILS_UNEARNED: 'unearned',
  OVERVIEW: 'overview',
  SELECTIONS_VOUCHER: 'selections-voucher',
  SUMMARY: 'summary',
};

export const ASSETS_PATHS = {
  OVERVIEW: 'overview',

  CHOICES_1: 'choices-1',
  CHOICES_2: 'choices-2',
  CHOICES_3: 'choices-3',

  DETAILS_CASH: 'cash',
  DETAILS_CHECKINGS: 'checkings',
  DETAILS_PAYCARD: 'paycard',
  DETAILS_CERTIFICATES: 'certificates',
  DETAILS_FEDERAL_TAX_REFUND_CREDIT: 'federal-tax-refund-credit',
  DETAILS_TRUST: 'trust',
  DETAILS_TREASURY_BILLS: 'treasury-bills',
  DETAILS_STOCKS: 'stocks',
  DETAILS_RETIREMENT: 'retirement',
  DETAILS_LIFE_INSURANCE: 'life-insurance',
  DETAILS_SOLD_ASSET: 'sold-assets',
  DETAILS_PROPERTY: 'property-investment',
  DETAILS_REAL_ESTATE: 'real-estate',
  DETAILS_OTHER_ASSETS: 'other-assets',

  SUMMARY: 'summary',
};

export const BEFORE_YOU_GO_PATHS = {
  ADDITIONAL_DETAILS: 'additional-details',
  VEHICLES: 'vehicles',
  PETS: 'pets',
  EMERGENCY_CONTACTS: 'emergency-contacts',
  VOLUNTARY_SELF_IDENTIFICATION: 'voluntary-self-identification',
};

export const UNINVITED_SECONDARY_USER_PATHS = {
  [IDENTIFYING_DETAILS_PATHS.IDENTIFICATION]: `${PATHS.IDENTIFYING_DETAILS}/${IDENTIFYING_DETAILS_PATHS.IDENTIFICATION}`,
  [CREDIT_CRIMINAL_CHECK_PATHS.CONSENT]: `${PATHS.CREDIT_CRIMINAL_CHECK}/${CREDIT_CRIMINAL_CHECK_PATHS.CONSENT}`,
  [APPLICATION_SUBMISSION_PATHS.SIGNATURE_AND_REPRESENTATION]: `${PATHS.APPLICATION_SUBMISSION}/${APPLICATION_SUBMISSION_PATHS.SIGNATURE_AND_REPRESENTATION}`,
  [BEFORE_YOU_GO_PATHS.VOLUNTARY_SELF_IDENTIFICATION]: `${PATHS.BEFORE_YOU_GO}/${BEFORE_YOU_GO_PATHS.VOLUNTARY_SELF_IDENTIFICATION}`,
};

export default PATHS;
